// import {
//   getCookie,
//   setCookie
// } from "../helpers";

$(function () {
  const $newsletterFooter = $('.site-footer .footer__main-content__newsletter__button');
  const $body = $('body');

  if ($newsletterFooter.length > 0) {
    const newsletterFormId = $newsletterFooter.attr('data-newsletter-id');
    const newsletterFormType = $newsletterFooter.attr('data-newsletter-form-type');
    if (newsletterFormId) {
      const $newsletterPopup = $(`.klaviyo-form-newsletter-wrapper[rel="${newsletterFormId}"]`);
      const $newsletterContent = $(`.klaviyo-form-newsletter-wrapper[rel="${newsletterFormId}"] > div`);
      const $newsletterPopupClose = $newsletterPopup.find('.klaviyo-form-newsletter-wrapper__close');

      $newsletterFooter.on('click', function () {
        if (newsletterFormType !== 'flyout' && typeof ($newsletterPopup) != 'undefined' && $newsletterPopup.length > 0) {
          if ($newsletterPopup) {
            $newsletterPopup.addClass('visible');
            $body.addClass('open-newsletter-popup');
          }
        } else {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', newsletterFormId]);
        }
      });

      if (typeof ($newsletterPopup) != 'undefined' &&
        $newsletterPopup.length > 0 &&
        typeof ($newsletterContent) != 'undefined' &&
        $newsletterContent.length > 0) {

        // if (!getCookie("auto_open_newsletter_popup")) {
        //   setTimeout(function () {
        //     $newsletterPopup.addClass('visible');
        //     $body.addClass('open-newsletter-popup');

        //     setCookie("auto_open_newsletter_popup", "true", 1);
        //   }, 30000);
        // }

        $newsletterPopup.on('click', function () {
          $newsletterPopup.removeClass('visible');
          $body.removeClass('open-newsletter-popup');
        });

        $newsletterContent.on('click', function (e) {
          e.stopPropagation();
        });

        $newsletterPopupClose.on('click', function (e) {
          e.preventDefault();
          $newsletterPopup.trigger('click');
        });
      }
    }
  }
});
